export default {
  getCheckinInfo: (state) => state.checkinInfo,
  isLoading: (state) => state.loading,
  getPublicPackages: (state) => state.publicPackages,
};
